import React from 'react';
import EChartsView from './EChartsView';
import { EChartsData, EChartsSeries } from './EChartsView';

export interface EChartsPresenterProps {
  data: EChartsData[] | EChartsSeries[];
  title?: string;
  type?: 'line' | 'bar' | 'pie' | 'gauge' | 'combined';
  height?: number;
  width?: number | string;
  showLegend?: boolean;
  showTooltip?: boolean;
  xAxisLabel?: string;
  yAxisLabel?: string;
  isLoading?: boolean;
  showDataZoom?: boolean;
}

export default function EChartsPresenter({
  data,
  title = "Graphique",
  type = 'line',
  height = 400,
  width = '100%',
  showLegend = true,
  showTooltip = true,
  xAxisLabel = "Temps",
  yAxisLabel = "Valeur",
  isLoading = false,
  showDataZoom = true
}: EChartsPresenterProps) {
  
  if (isLoading) {
    return (
      <div style={{ 
        height: height, 
        width: width, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        backgroundColor: '#ffffff',
        borderRadius: '16px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        border: '1px solid #e5e7eb'
      }}>
        <div style={{ color: '#6b7280', fontSize: '16px' }}>
          Chargement du graphique...
        </div>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div style={{ 
        height: height, 
        width: width, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        backgroundColor: '#ffffff',
        borderRadius: '16px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        border: '1px solid #e5e7eb'
      }}>
        <div style={{ color: '#6b7280', fontSize: '16px' }}>
          Aucune donnée disponible
        </div>
      </div>
    );
  }

  return (
    <EChartsView
      data={data}
      title={title}
      type={type}
      height={height}
      width={width}
      showLegend={showLegend}
      showTooltip={showTooltip}
      xAxisLabel={xAxisLabel}
      yAxisLabel={yAxisLabel}
      showDataZoom={showDataZoom}
    />
  );
}
